import { useParams } from "react-router";
import { AssignedResourcesTable } from "@/components/AssignedResourcesTable";

interface ConnectorAssignment {
  connectorId: string;
  reachable: boolean | null;
  lastCheckedAt: string | null;
  online: boolean;
}

interface Resource {
  id: string;
  name: string;
  type: string;
  kind: string | null;
  address: string;
  port: number;
  connectors: ConnectorAssignment[];
}

export function ConnectorResources() {
  const { orgId, connectorId } = useParams();

  return (
    <AssignedResourcesTable<Resource>
      endpoint={`/organizations/${orgId}/connectors/${connectorId}/resources`}
      emptyTitle="No resources reached through this connector"
      emptyMessage="Assign this connector from a resource's own page."
      getAssignment={(resource) =>
        resource.connectors.find((c) => c.connectorId === connectorId)
      }
    />
  );
}
